<template>
  <el-container class="content" style="display: block;">

	<el-container class="lables">

		<el-row  class="la-list">
			<el-col :span="8" class="first">
				<el-row>
          <div class="dz">动作</div>
					<el-button type="primary" @click="addDz()" style="width: 100%;background-color: #FFA500;" v-if="this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi' || this.$store.getters.getRole == 'ui'">添加</el-button>
				</el-row>
        <el-row class="lable-o-l lable-o-ls" v-if="addDzT == 1">
            <el-input v-model="dz_id" :disabled="dz_idT" placeholder="请输入编号" style="margin-bottom: 10px;"></el-input>
            <el-input v-model="dz_name" placeholder="请输入动作名称"style="margin-bottom: 10px;"></el-input>
            <el-button type="primary" @click="addDzDo()" style="width: 100%;background-color: #3A8EE6;">确认</el-button>
        </el-row>
				<el-row class="lable-o-l lable-o-ls">
					<el-col :span="8">动作编号</el-col>
					<el-col :span="8">动作名称</el-col>
          <el-col :span="8">操作</el-col>
				</el-row>
        <el-row class="lable-o-l lable-o-ls" v-for="(item,index) in dzlist" :key="index">
        	<el-col :span="8">{{item.d_id}}</el-col>
        	<el-col :span="8">{{item.name}}</el-col>
        	<el-col :span="8" @click.native='changeDz(item.d_id,item.name)' style="color: #0000FF;" >修改</el-col>
        </el-row>
			</el-col>
      <el-col :span="8" class="first">
      	<el-row>
      		<div class="dz">（组\组合）名称</div>
          <el-button type="primary" @click="addZZ()" style="width: 100%;background-color: #FFA500;" v-if="this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi' || this.$store.getters.getRole == 'ui'">添加</el-button>
      	</el-row>
        <el-row class="lable-o-l lable-o-ls" v-if="addZZT == 1">
            <el-input v-model="zzName"  placeholder="请输入名称" style="margin-bottom: 10px;"></el-input>
            <el-select v-model="valueZZ" placeholder="请选择分类" style="margin-bottom: 10px;width: 100%;">
                <el-option
                  v-for="item in zzlist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            <el-button type="primary" @click="addZZDo()" style="width: 100%;background-color: #3A8EE6;">确认</el-button>
        </el-row>
      	<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in zhlist" :key="index">
      		<div class="lable-o" @click="chose(item.id)">{{item.name}}</div>
      	</el-row>
      </el-col>
			<el-col :span="8" class="two">
				<el-row>
					<div class="dz">（组\组合）详情</div>
					<el-button type="primary" @click="addZh()" style="width: 100%;background-color: #FFA500;" v-if="this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi' || this.$store.getters.getRole == 'ui'">添加</el-button>
				</el-row>
        <el-row class="lable-o-l lable-o-ls" v-if="addZhT == 1">
            <el-input v-model="zh_time"  placeholder="请输入动作时间" style="margin-bottom: 10px;"></el-input>
            <el-select v-model="value" placeholder="请选择动作" style="margin-bottom: 10px;width: 100%;">
                <el-option
                  v-for="item in dzlist"
                  :key="item.d_id"
                  :label="item.name"
                  :value="item.d_id">
                </el-option>
              </el-select>
            <el-button type="primary" @click="addZhDo()" style="width: 100%;background-color: #3A8EE6;">确认</el-button>
        </el-row>
				<el-row class="lable-o-l lable-o-ls">
					<el-col :span="6">动作编号</el-col>
					<el-col :span="6">动作名称</el-col>
          <el-col :span="6">动作时间</el-col>
          <el-col :span="6" v-if="this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi' || this.$store.getters.getRole == 'ui'">操作</el-col>
				</el-row>
				<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in zhlistd" :key="index">
					<el-col :span="6">{{item.d_id}}</el-col>
					<el-col :span="6">{{item.name}}</el-col>
          <el-col :span="6">{{item.times}}</el-col>
          <el-col :span="6" @click.native='del(item.id)' style="color: #0000FF;" >删除</el-col>
				</el-row>
			</el-col>
		</el-row>

	</el-container>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose">
    <span>确认删除？</span>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="dialogVisible = false">取 消</el-button>
  	<el-button type="primary" @click="doDell()">确 定</el-button>
    </span>
  </el-dialog>

  </el-container>
</template>

<script>

  export default {
    data() {
      return {
        dzlist:[],
        zzlist:[{'id':1,'name':'组合'},{'id':2,'name':'组'}],
        zhlist:[],
        zhlistd:[],
        zh_p_id:0,
        addDzT:0,
        dz_id:'',
        value:1,
        zzName:'',
        valueZZ:2,
        dz_idT:false,
        dz_name:'',
        dzurl:'http://y31p.yoooooo.com/index.php/index/data/addDzDo',
        addDzType:1,
        addZhT:0,
        addZZT:0,
        zh_time:'',
        del_id:0,
        dialogVisible:false,
        token:window.localStorage.getItem('token'),
        userId:window.localStorage.getItem('id'),
        url:this.$store.getters.getUrl
      };
    },
	directives: {

    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
       this.loadDzlist();
       this.loadzhlist();


    },

	methods:{
		loadDzlist(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF
				},
				url:'http://y31p.yoooooo.com/index.php/index/data/getDzList'
			})
			.then(res=>{
				this.dzlist = res.data;

			})
			.catch(err=>{

			});
		},
		loadzhlist(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF
				},
				url:'http://y31p.yoooooo.com/index.php/index/data/getzHList'
			})
			.then(res=>{
				this.zhlist = res.data;

			})
			.catch(err=>{

			});
		},
    loadzhlistD(id){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
    			id:this.zh_p_id
    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/getzHListD'
    	})
    	.then(res=>{
    		this.zhlistd = res.data;

    	})
    	.catch(err=>{

    	});
    },
		chose(id){
			this.zh_p_id = id;
			this.loadzhlistD();
      this.addZhT = 0
      this.zh_time = ''
      this.value = 1
		},
    addDz(){
      this.addDzT = 1
      this.dz_id = ''
      this.dz_name = ''
      this.dz_idT = false
      this.addDzType = 1
      this.dzurl = 'http://y31p.yoooooo.com/index.php/index/data/addDzDo'
    },
    addZZ(){
      this.addZZT = 1
      this.zzName = ''
      this.valueZZ = 2
    },
    changeDz(id,name){
      if(this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi' || this.$store.getters.getRole == 'ui'){
        this.addDzT = 1
        this.dz_id = id
        this.dz_idT = true
        this.dz_name = name
        this.addDzType = 2
        this.dzurl = 'http://y31p.yoooooo.com/index.php/index/data/changeDzDo'
      }else{
        this.$message({
        	type: 'error',
        	message: '无权限'
        });
      }

    },
    addZh(){
      this.addZhT = 1
    },
    addZZDo(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.zzName == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		type:this.valueZZ,
          name:this.zzName,
          token:this.token,
          userId:this.userId
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/changeZZDo'
      })
      .then(res=>{
      	if(res.data.code == 200){
          this.addZZT = 0
          this.zzName = ''
          this.valueZZ = 2
          this.loadzhlist();


           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
      	}else{
      		this.addDzT = 0
      		alert(res.data.msg)
      	}

      })
      .catch(err=>{

      });
    },
    addZhDo(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.zh_time == ''){
         return false
      }
      if(this.zh_p_id == 0){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.value,
          p_id:this.zh_p_id,
      		times:this.zh_time,
          token:this.token,
          userId:this.userId
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/changeZhDo'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.addZhT = 0
           this.loadzhlistD();
           this.zh_time = ''
           this.value = 1

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
      	}else{
      		this.addDzT = 0
      		alert(res.data.msg)
      	}

      })
      .catch(err=>{

      });
    },
    addDzDo(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.dz_id == ''){
         return false
      }
      if(this.dz_name == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.dz_id,
      		name:this.dz_name,
          token:this.token,
          userId:this.userId
      	},
      	url:this.dzurl
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.addDzT = 0
           this.loadDzlist();
           this.dz_id = ''
           this.dz_name = ''
           this.dz_idT = false
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
      	}else{
      		this.addDzT = 0
      		alert(res.data.msg)
      	}

      })
      .catch(err=>{

      });
    },



		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},
    del(id){
      if(this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi' || this.$store.getters.getRole == 'ui'){
        this.del_id = id
        this.dialogVisible = true
      }else{
        this.$message({
        	type: 'error',
        	message: '无权限'
        });
      }

    },
    doDell(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.del_id == 0){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.del_id,
          token:this.token,
          userId:this.userId
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/zHDell'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.del_id = 0
           this.dialogVisible = false
           this.loadzhlistD();
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });

      	}else{
           this.dialogVisible = false
      	}

      })
      .catch(err=>{

      });
    },

	}


  }
</script>

<style>

	.content{
		background: #939AA0;
		width: 100%;
		height: 100%;
	}
	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}

	.zhuyi{
		color: red;
    margin-left: 120px;
    font-size: 20px;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{
		margin-left: 5%;
		margin-right: 5%;
		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list{
		margin-top: 50px;
		width: 100%;
		margin-left: 20%;
		margin-right: 20%;
	}
	.first{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
  .dz{
  	text-align: center;
  	width: 96%;
  	font-size: 35px;
  	height: 40px;
  	line-height: 40px;
  	margin-left: 2%;
    margin-bottom: 10px;
  }
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{

		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;

	}
	.lable-two{

		text-align: center;
		background: #c6c6c6;

		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchT{
		width: 80%;
		margin-left: 10%;
		height: 30px;
	}
	.lable-o-ls{
		border-bottom: 1px solid #c6c6c6;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/dz.vue